import { FunctionComponent } from 'react'
import { Fraction } from '@black-bear-energy/black-bear-energy-common'
import { Tooltip } from '@black-bear-energy/rucksack'
import { LabeledProgressBar } from './LabeledProgressBar'

export const RequiredDocumentsProgressBar: FunctionComponent<
  RequiredDocumentsProgressBarProps
> = ({ required }) => {
  const tooltipTitle = `${required.numerator}/${required.denominator} Required Documents Uploaded`

  return (
    <Tooltip title={tooltipTitle}>
      <LabeledProgressBar
        numerator={required.numerator}
        denominator={required.denominator}
      />
    </Tooltip>
  )
}

interface RequiredDocumentsProgressBarProps {
  required: Fraction
}
